import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useState } from "react";
import { useLiveMetricsSheetState } from "@/hooks/useLiveMetricsSheetState";
const LiveMetricsIndicator = dynamic(() => import("./LiveMetricsIndicator"), {
  ssr: false
});

// Stays mounted after the first open so the sheet keeps its state and close animation.
const LiveMetricsSheetLoader = () => {
  const $ = _c(1);
  const {
    isOpen
  } = useLiveMetricsSheetState();
  const [hasOpened, setHasOpened] = useState(false);
  if (isOpen && !hasOpened) {
    setHasOpened(true);
  }
  if (!hasOpened) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LiveMetricsIndicator hideIndicator={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default LiveMetricsSheetLoader;